import { useQuery, useMutation } from '@tanstack/react-query';
import { getApplication, getApplicationStatus } from '../../../services/dashboard';
import { viewDocument } from '../../../services/uploadDocuments';

const isComplete = (status) => status === 'COMPLETE';

export const useApplicationDetails = (listId) => {
  const statusQuery = useQuery({
    queryKey: ['applicationStatus', listId],
    queryFn: () => getApplicationStatus(listId),
    enabled: !!listId,
  });

  // { verificationStatus, extractionStatus, analysisStatus, assessmentStatus, reportStatus }
  const statusInfo = statusQuery.data?.statusInfo?.statusInfo;

  const allComplete =
    !!statusInfo &&
    isComplete(statusInfo.verificationStatus) &&
    isComplete(statusInfo.extractionStatus) &&
    isComplete(statusInfo.analysisStatus) &&
    isComplete(statusInfo.assessmentStatus) &&
    isComplete(statusInfo.reportStatus);

  // Only fetch the full application (documents grid) once we know the
  // application has actually finished the whole pipeline — no point
  // fetching it if we're about to redirect back into the flow.
  const applicationQuery = useQuery({
    queryKey: ['applicationDetails', listId],
    queryFn: () => getApplication(listId),
    enabled: !!listId && statusQuery.isSuccess && allComplete,
  });

  const viewDocumentMutation = useMutation({
    mutationFn: (payload) => viewDocument(payload),
    onSuccess: (response) => {
      const url = response?.url || response?.data?.url || response;
      if (url) window.open(url, '_blank', 'noopener,noreferrer');
    },
  });

  const handleViewDocument = (documentId) => {
    viewDocumentMutation.mutate({ documentId, applicationId: listId });
  };

  return {
    statusQuery,
    statusInfo,
    allComplete,
    applicationQuery,
    applicationData: applicationQuery.data?.list?.applicationData,
    documentData: applicationQuery.data?.list?.documentData ?? [],
    reportData: applicationQuery.data?.list?.reportData ?? [],
    handleViewDocument,
    viewDocumentMutation,
  };
};
